import { useState } from 'react';
import { IconCheck } from '@tabler/icons-react';
import { useFela } from 'react-fela';
import { FormattedMessage } from 'react-intl';

import { Label, SelectInput, type SelectInputProps } from '@/modules/forms';
import { LabelSize } from '@/modules/forms/components/Label/Label.rules';
import type { FormattedMessageProps } from '@/modules/localizations';
import { Caret } from '@/modules/ui/components/Icon/Caret';

import * as felaRules from './SelectFilter.rules';

export interface SecretTypeFilterProps extends SelectInputProps {
    label: FormattedMessageProps;
}

export const SelectFilter = ({ label, onOpenChange, ...rest }: SecretTypeFilterProps) => {
    const { css } = useFela();

    const [open, setOpen] = useState(false);

    return (
        <div className={css(felaRules.container)}>
            <Label size={LabelSize.SMALL} customStyle={felaRules.label}>
                <FormattedMessage {...label} />
            </Label>
            <SelectInput
                {...rest}
                onOpenChange={isOpen => {
                    setOpen(isOpen);
                    onOpenChange?.(isOpen);
                }}
                suffixIcon={<Caret className={css(open ? felaRules.caretOpen : felaRules.caret)} />}
                menuItemSelectedIcon={<IconCheck size={16} className={css(felaRules.check)} />}
                customStyle={felaRules.select}
                classNames={{ popup: { root: css(felaRules.dropdown) } }}
                variant='borderless'
            />
        </div>
    );
};
